import { render, staticRenderFns } from "./ProxyHolderChipList.vue?vue&type=template&id=27c9d5ac&scoped=true"
import script from "./ProxyHolderChipList.vue?vue&type=script&lang=js"
export * from "./ProxyHolderChipList.vue?vue&type=script&lang=js"
import style0 from "./ProxyHolderChipList.vue?vue&type=style&index=0&id=27c9d5ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c9d5ac",
  null
  
)

export default component.exports